import { imageFile } from 'common/helpers/miscHelpers';

const Picture = (props) => {
  const { image, alt, size } = props;

  if (!image.formats) {
    const src = imageFile(image.src, size);
    return <img src={src} alt={alt} loading="lazy" />;
  }

  const { avif, src, webp } = image.formats[size];

  return (
    <picture>
      <source srcSet={avif} type="image/avif" />
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} />
    </picture>
  );
};

export default Picture;
